// Base selector for the loan overrides slice
export const selectLoanOverridesState = (state) => state?.loanOverrides

// Selectors for loan overrides data
export const selectLoanOverridesData = (state) => selectLoanOverridesState(state)?.overrides?.data

export const selectLoanOverridesLoading = (state) => selectLoanOverridesState(state)?.overrides?.isLoading || false

export const selectLoanOverridesError = (state) => selectLoanOverridesState(state)?.overrides?.error
